import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuroraTextComponent } from '@shared/components/aurora-text/aurora-text.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { InvitesComponent } from '@shared/components/user/invites/invites.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [AuroraTextComponent, TranslocoPipe, InvitesComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {}
